import {
  Box,
  Button,
  Divider,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useContext } from "react";
import Title from "../../../components/Title";
import styles from "./InputForm.module.css";
import Subtitle from "../../../components/BodyText";
import ActivationFormContext from "../../../store/activation-form-context";
import LoadingOverlay from "../../../components/LoadingOverlay";
import ButtonContinueIcon from "../../../components/icons/ButtonContinueIcon";
import { BOUGHT_FROM_OPTIONS, HEARD_FROM_OPTIONS } from "../../../util/constants";

const InputForm = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("md"));
  const {
    imeiInputValue,
    imeiInputChangeHandler,
    imeiInputError,
    selectValue,
    selectValueChangeHandler,
    selectValueError,
    hearAboutUsValue,
    hearAboutUsChangeHandler,
    hearAboutUsError,
    formSubmitHandler,
    loading,
    disableSubmit,
  } = useContext(ActivationFormContext);

  return (
    <Box 
      sx={{
        maxWidth: {
          xs: "100%",
          md: "540px",
        },
        pr: {
          xs: 0,
          md: "20px",
        }
      }}
    >
      <Title sx={{ fontSize: "36px", mt: "15px" }}>Let&apos;s get started</Title>
      <Subtitle sx={{ fontSize: "16px", mb: "30px", mt: "10px", fontWeight: 400 }}>
        Enter the 15-digit number on the back of your watch.
      </Subtitle>

      <FormLabel sx={{ fontSize: "14px" }}>IMEI</FormLabel>
      <TextField
        sx={{ mt: "5px" }}
        value={imeiInputValue}
        onChange={imeiInputChangeHandler}
        error={!!imeiInputError}
        fullWidth
        placeholder="Enter IMEI"
      />
      {imeiInputError ? <Typography color="error">{imeiInputError}</Typography> : undefined}
      <Divider
        orientation="vertical"
        sx={{
          height: "auto",
          mb: {
            xs: "20px",
            md: "30px",
          },
        }}
      />
      <FormControl fullWidth>
        <FormLabel sx={{ fontSize: "14px" }}>Where did you buy your watch?</FormLabel>
        <Select
          value={selectValue}
          onChange={selectValueChangeHandler}
          error={!!selectValueError}
          sx={{ mt: "5px" }}
          displayEmpty
          renderValue={(selected) => {
            if (selected === "") {
              return <Typography color="text.secondary">Select an option</Typography>;
            }
            return BOUGHT_FROM_OPTIONS.find((option) => String(option.id) === selected)?.label;
          }}
        >
          {BOUGHT_FROM_OPTIONS.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {selectValueError ? <Typography color="error">{selectValueError}</Typography> : undefined}
      <Divider
        orientation="vertical"
        sx={{
          height: "auto",
          mb: {
            xs: "20px",
            md: "30px",
          },
        }}
      />
      <FormControl fullWidth>
        <FormLabel sx={{ fontSize: "14px" }}>How did you first hear about Cosmo?</FormLabel>
        <Select
          value={hearAboutUsValue}
          onChange={hearAboutUsChangeHandler}
          error={!!hearAboutUsError}
          sx={{ mt: "5px" }}
          displayEmpty
          renderValue={(selected) => {
            if (selected === "") {
              return <Typography color="text.secondary">Select an option</Typography>;
            }
            return HEARD_FROM_OPTIONS.find((option) => String(option.id) === selected)?.label;
          }}
        >
          {HEARD_FROM_OPTIONS.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {hearAboutUsError ? <Typography color="error">{hearAboutUsError}</Typography> : undefined}
      <Divider
        orientation="vertical"
        sx={{
          height: "auto",
          mb: "30px",
        }}
      />
      <div className={styles.buttons}>
        <Button
          variant="contained"
          sx={{
            mb: "2rem",
            boxShadow: "none",
            fontSize: "16px",
            fontWeight: 500,
            gap: 2,
            lineHeight: "1.4",
          }}
          onClick={formSubmitHandler}
          fullWidth
          disabled={disableSubmit}
          endIcon={<ButtonContinueIcon />}
        >
          {isSm ? "Continue" : "Continue to memberships"}
        </Button>
      </div>
      <LoadingOverlay loading={loading} />
    </Box>
  );
};
export default InputForm;
